/* eslint-disable max-lines */
import './global_d';

export { AttributesSelectComponent } from './lib/attributes/attributes-select/attributes-select.component';
export { AttributesSelectListComponent } from './lib/attributes/attributes-select-list/attributes-select-list.component';
export { AttributesComponent } from './lib/attributes/attributes.component';
export { InputAttributesComponent } from './lib/attributes/input-attributes/input-attributes.component';
export type {
  ListTemplateContext,
  AttributesLoadMore,
  TranslationsContextType,
} from './lib/attributes/attributes.types';
export {
  RtUIAttributesTranslations,
  TranslationsContext,
  provideAttributesTranslations,
  CREATE_NEW_ITEM_ID,
} from './lib/attributes/attributes.types';
export { BoxPlaceloaderComponent } from './lib/box-placeloader/box-placeloader.component';
export { Breakpoint, NewBreakpoint } from './lib/breakpoints';
export { AsyncCdkDrag } from './lib/cdk-overrides/async-cdk-drag.directive';
export { ClipboardCopy } from './lib/clipboard-copy.service';
export { ColorPickerComponent } from './lib/color-picker/color-picker.component';
export { ColorPickerDirective } from './lib/color-picker/color-picker.directive';
export { AddLineComponent } from './lib/common/add-line/add-line.component';
export { AdminsAvatarsComponent } from './lib/common/admins-avatars/admins-avatars.component';
export { AvatarComponent } from './lib/common/avatar/avatar.component';
export type { AvatarSize, AvatarContext } from './lib/common/avatar/avatar.types';
export { AvatarRsvpBadge } from './lib/common/avatar/avatar.types';
export { BadgeComponent } from './lib/common/badge/badge.component';
export { ChipsComponent } from './lib/common/chips/chips.component';
export type { BadgeColor } from './lib/common/badge/badge.types';
export { BoxComponent } from './lib/common/box/box.component';
export { BaseButtonDirective } from './lib/common/button/base-button';
export { BUTTONS } from './lib/common/button/buttons';
export { setInputs, ExtendableButton } from './lib/common/button/button.types';
export type {
  RtButtonVariant,
  RtInfoboxButtonVariant,
  RtPlanButtonVariant,
  RtWalkthroughButtonVariant,
  RtButtonColorContextVariant,
} from './lib/common/button/button.types';
export { AddNewButtonComponent } from './lib/common/button/components/add-new-button/add-new-button.component';
export { ButtonComponent } from './lib/common/button/components/button/button.component';
export { IconButtonComponent } from './lib/common/button/components/icon-button/icon-button.component';
export { PlanButtonComponent } from './lib/common/button/components/plan-button/plan-button.component';
export { ButtonDropdownIndicatorDirective } from './lib/common/button/directives/button-dropdown/button-dropdown-indicator.directive';
export { ButtonLoadingDirective } from './lib/common/button/directives/button-loading/button-loading.directive';
export { CandidateRatingComponent } from './lib/common/candidate-rating/candidate-rating.component';
export { CandidatesAvatarsComponent } from './lib/common/candidates-avatars/candidates-avatars.component';
export { CardComponent } from './lib/common/card/card.component';
export { CircularProgressIndicatorComponent } from './lib/common/circular-progress-indicator/circular-progress-indicator.component';
export {
  CODE_INPUT_VALUE_ACCESSOR,
  CodeInputComponent,
} from './lib/common/code-input/code-input.component';
export { TimeAgoAsyncPipe } from './lib/common/date/pipes/time-ago-async.pipe';
export { TimeAgoBase } from './lib/common/date/pipes/timeago';
export { TimeAgoPipe } from './lib/common/date/pipes/timeago.pipe';
export { DateComponent } from './lib/common/date/rt-date/date.component';
export { DividerComponent } from './lib/common/divider/divider.component';
export { DotComponent } from './lib/common/dot/dot.component';
export { PreventDragDropDirective } from './lib/common/drag-and-drop/prevent-dragdrop.directive';
export { DropdownHeaderComponent } from './lib/common/dropdown/dropdown-header/dropdown-header.component';
export { DropdownItemComponent } from './lib/common/dropdown/dropdown-item/dropdown-item.component';
export { NestedTemplateTriggerDirective } from './lib/common/dropdown/dropdown-nested-templates/nested-template-trigger.directive';
export { DropdownComponent, DropdownWidth } from './lib/common/dropdown/dropdown.component';
export { OverlayHoverTriggerDirective } from './lib/common/dropdown/directives/overlay-hover-trigger.directive';
export { EmptyStateComponent } from './lib/common/empty-state/empty-state.component';
export { FabButtonComponent } from './lib/common/fab-button/fab-button.component';
export { GroupComponent } from './lib/common/group/group.component';
export { HeadingComponent } from './lib/common/heading/heading.component';
export type { HotkeyConfigs } from './lib/common/hotkey/hotkey.component';
export { HotkeyComponent, Os } from './lib/common/hotkey/hotkey.component';
export type { IconHelpWithDropdownTranslations } from './lib/common/icon-help-with-dropdown/icon-help-with-dropdown.component';
export {
  IconHelpWithDropdownComponent,
  IconHelpWithDropdownTranslationsToken,
} from './lib/common/icon-help-with-dropdown/icon-help-with-dropdown.component';
export { IconHelpComponent } from './lib/common/icon-help/icon-help.component';
export type { IconToken } from './lib/common/icon/directives/icon-color.directive';
export { IconColorDirective } from './lib/common/icon/directives/icon-color.directive';
export type { IconSize } from './lib/common/icon/icon.component';
export { IconComponent, IconSizes } from './lib/common/icon/icon.component';
export type { BackgroundColors } from './lib/common/icon-container/icon-container.component';
export { IconContainerComponent } from './lib/common/icon-container/icon-container.component';
export { IntegrationItemComponent } from './lib/common/integration-item/integration-item.component';
export { InterviewEvaluationRatingComponent } from './lib/common/interview-evaluation-rating/interview-evaluation-rating.component';
export { ItemComponent } from './lib/common/item/item.component';
export { LabelComponent } from './lib/common/label/label.component';
export { ListComponent } from './lib/common/list/list.component';
export { MailPickerComponent } from './lib/common/mail-picker/mail-picker.component';
export { MessageComponent } from './lib/common/message/message.component';
export { OfferStatusIndicatorComponent } from './lib/common/offer-status-indicator/offer-status-indicator.component';
export { PaginationCounterComponent } from './lib/common/pagination-counter/pagination-counter.component';
export { PaginationComponent } from './lib/common/pagination/pagination.component';
export { AdminFilterPipe } from './lib/common/pipes/admin-filter.pipe';
export { BoldTextPipe } from './lib/common/pipes/bold-text.pipe';
export { CurrencyPipe } from './lib/common/pipes/currency.pipe';
export { DateFormatTimezonePipe } from './lib/common/pipes/date-format-timezone.pipe';
export { DaysLeftPipe } from './lib/common/pipes/days-left.pipe';
export { DurationPipe } from './lib/common/pipes/duration.pipe';
export { EncodeHTMLPipe } from './lib/common/pipes/encode-html.pipe';
export { FileSizePipe } from './lib/common/pipes/file-size.pipe';
export { MathPipe } from './lib/common/pipes/math.pipe';
export { ProductSelectableCardComponent } from './lib/common/product-selectable-card/product-selectable-card.component';
export { RemoveHTMLTagsPipe } from './lib/common/pipes/remove-html-tags.pipe';
export { RoundNumberPipe } from './lib/common/pipes/round-number.pipe';
export { SafeHtmlPipe } from './lib/common/pipes/safe-html.pipe';
export { SimpleFormatPipe } from './lib/common/pipes/simple-format.pipe';
export { SourceNamePipe } from './lib/common/pipes/source-name.pipe';
export { TruncatePipe } from './lib/common/pipes/truncate.pipe';
export { TranslateDropdownItemsPipe } from './lib/common/pipes/translate-dropdown-items.pipe';
export { PreventOrphansPipe } from './lib/common/pipes/prevent-orphans.pipe';
export { PlaceloaderComponent } from './lib/common/placeloader/placeloader.component';
export { ProgressBarComponent } from './lib/common/progress-bar/progress-bar.component';
export { ProgressComponent } from './lib/common/progress/progress.component';
export {
  RecruiteeLogoComponent,
  RecruiteeLogoType,
} from './lib/common/recruitee-logo/recruitee-logo.component';
export { ResultsLimitButtonComponent } from './lib/common/results-limit-button/results-limit-button.component';
export type {
  LanguageSwitcherItem,
  SegmentedButtonType,
} from './lib/common/segmented-control/segmented-control-button/segmented-control-button.component';
export { SegmentedControlButtonComponent } from './lib/common/segmented-control/segmented-control-button/segmented-control-button.component';
export { SegmentedControlComponent } from './lib/common/segmented-control/segmented-control.component';
export { SpinnerComponent } from './lib/common/spinner/spinner.component';
export { SparksAnimationComponent } from './lib/common/sparks-animation/sparks-animation.component';
export { SubscriptionBannerComponent } from './lib/common/subscription-banner/subscription-banner.component';
export { diffDates } from './lib/common/subscription-banner/subscription-banner.helpers';
export { SubscriptionBannerTypeOptions } from './lib/common/subscription-banner/subscription-banner.types';
export { TableComponent } from './lib/common/table/table.component';
export { TabComponent } from './lib/common/tabs/tab/tab.component';
export { TabsComponent } from './lib/common/tabs/tabs.component';
export { TagComponent } from './lib/common/tag/tag.component';
export { ToolbarGroupComponent } from './lib/common/toolbar/toolbar-group/toolbar-group.component';
export { ToolbarPrimaryComponent } from './lib/common/toolbar/toolbar-primary/toolbar-primary.component';
export { ToolbarSecondaryComponent } from './lib/common/toolbar/toolbar-secondary/toolbar-secondary.component';
export { ToolbarComponent } from './lib/common/toolbar/toolbar/toolbar.component';
export type { TooltipPosition } from './lib/common/tooltip/tooltip-inner.component';
export { TooltipInnerComponent } from './lib/common/tooltip/tooltip-inner.component';
export { TooltipComponent } from './lib/common/tooltip/tooltip.component';
export { RtTooltip } from './lib/common/tooltip/tooltip.directive';
export { TruncateComponent } from './lib/common/truncate/truncate.component';
export type { Variants } from './lib/common/variant/variant';
export { ComponentVariant } from './lib/common/variant/variant';
export { WindowRef } from './lib/common/window-ref';
export { BaseTooltipComponent } from './lib/component-tooltip/base-tooltip.component';
export { ComponentTooltipService } from './lib/component-tooltip/component-tooltip.service';
export {
  COMPONENT_TOOLTIP_RESIZE_PROVIDERS,
  ComponentTooltipResizeDispatcher,
} from './lib/component-tooltip/resize-providers';
export type { ComponentTooltipServiceConfig } from './lib/component-tooltip/types';
export type { ArrowPosition, OverlayClipArea } from './lib/component-tooltip/types';
export {
  ComponentPositionPair,
  ComponentTooltipPosition,
  ObserveOnElement,
} from './lib/component-tooltip/types';
export { CopyInputComponent } from './lib/copy-text/copy-input/copy-input.component';
export { CopyTextDropdownComponent } from './lib/copy-text/copy-text-dropdown/copy-text-dropdown.component';
export { ClickToCopyDirective } from './lib/copy-text/directives/click-to-copy.directive';
export type { HotkeyPressEvent } from './lib/core/a11y/hotkeys.service';
export { HotkeysService } from './lib/core/a11y/hotkeys.service';
export { InteractionEventDirective } from './lib/core/a11y/interactions-event.directive';
export { ScrollTrapDirective } from './lib/core/a11y/scroll-trap';
export { KeyCode, ModifierKey, KeySymbol } from './lib/core/keycode';
export * from './lib/core/platform/platform';
export {
  ConnectedOverlayDirective,
  OverlayOriginDirective,
  OverlayPosition,
} from './lib/core/overlay/overlay-directives';
export { ScrollableDirective } from './lib/core/overlay/scroll/scrollable.directive';
export { RtPlatform } from './lib/core/platform/platform';
export { ThemeToggleComponent } from './lib/common/theme-toggle/theme-toggle.component';
export { DataTableOptionsButtonComponent } from './lib/data-table/data-table-options-button/data-table-options-button.component';
export { DataTableComponent } from './lib/data-table/data-table/data-table.component';
export type {
  DataTableColumnOptions,
  DataTableColumnsCache,
} from './lib/data-table/data-table.types';
export type {
  DataTableColumnGeometryChange,
  DataTableColumnWithVisibility,
  DataTableCellContext,
  DataTableColumn,
  DataTableRow,
  TableCellFactoryResult,
  TableCellFactory,
  NewDataTableColumn,
  ColumnFactory,
} from './lib/data-table/data-table.types';
export { DateCellComponent } from './lib/data-table/cells/date-cell.component';
export { ExpandableCellComponent } from './lib/data-table/cells/expandable-cell/expandable-cell.component';
export {
  TagsCellComponent,
  tagsCellFactory,
} from './lib/data-table/cells/tags-cell/tags-cell.component';
export {
  EMPTY_CELL,
  TextCellComponent,
  textCellFactory,
} from './lib/data-table/cells/text-cell.component';
export { HtmlCellComponent, htmlCellFactory } from './lib/data-table/cells/html-cell.component';
export { TABLE_CELL_TIME_FORMAT } from './lib/data-table/cells/transform-functions';
export { cellTransformFullDate } from './lib/data-table/cells/transform-functions';
export { UserCellComponent } from './lib/data-table/cells/user-cell/user-cell.component';
export { usersAvatarsCellFactory } from './lib/data-table/cells/users-avatar-cell.component';
export { defineTableColumn } from './lib/data-table/data-table.types';
export {
  DateRangePickerLabelPipe,
  getDateRangePickerLabel,
} from './lib/date-range-picker/date-range-picker-label.pipe';
export {
  DateRangePickerComponent,
  getDateRangeValueDates,
} from './lib/date-range-picker/date-range-picker.component';

export { DialogOutletDirective } from './lib/dialog-outlet/dialog-outlet.directive';
export { keepChildrenOutlets, stripChildrenOutlets } from './lib/dialog-outlet/url-tree-utils';
export { DialogBodyComponent } from './lib/dialog/dialog-body/dialog-body.component';
export { DialogCloseComponent } from './lib/dialog/dialog-close/dialog-close.component';
export type { DialogConfigOptions, DialogConfig } from './lib/dialog/dialog-config';
export { buildDialogConfig, DialogWidth } from './lib/dialog/dialog-config';
export { DialogContainerComponent } from './lib/dialog/dialog-container/dialog-container.component';
export { DialogFooterComponent } from './lib/dialog/dialog-footer/dialog-footer.component';
export { DialogHeaderComponent } from './lib/dialog/dialog-header/dialog-header.component';
export { DialogData, DialogInjector } from './lib/dialog/dialog-injector';
export { OVERLAY_LEVEL } from './lib/dialog/providers';
export { DialogOpenerService } from './lib/dialog/dialog-opener.service';
export { DialogRef } from './lib/dialog/dialog-ref';
export { DialogToolbarComponent } from './lib/dialog/dialog-toolbar/dialog-toolbar.component';
export type { DialogComponentI } from './lib/dialog/dialog.component';
export { ConfirmDialogComponent } from './lib/dialogs/confirm-dialog/confirm-dialog.component';
export { DialogService } from './lib/dialogs/dialogs.service';
export { IllustrationDialogComponent } from './lib/dialogs/illustration-dialog/illustration-dialog.component';
export { ProtectedControlsDialogComponent } from './lib/dialogs/protected-controls-dialog/protected-controls-dialog.component';
export { DropdownScrollableComponent } from './lib/dropdown-scrollable/dropdown-scrollable.component';
export { BulkSelectComponent } from './lib/forms/bulk-select/bulk-select.component';
export { BulkSelectionMessagesComponent } from './lib/forms/bulk-selection-messages/bulk-selection-messages.component';
export { SelectableCardComponent } from './lib/forms/checkbox-card/selectable-card.component';
export { CheckboxComponent } from './lib/forms/checkbox/checkbox.component';
export { DatePickerComponent } from './lib/forms/date-picker/date-picker.component';
export { EmailsInputComponent } from './lib/forms/emails-input/emails-input.component';
export type {
  AttachmentAvatarData,
  AttachmentAvatarDataResolver,
} from './lib/forms/file-upload/attachment-item/attachment-item.component';
export {
  AttachmentItemComponent,
  ATTACHMENT_AVATAR_DATA_RESOLVER,
} from './lib/forms/file-upload/attachment-item/attachment-item.component';
export { AttachmentPlaceloaderComponent } from './lib/forms/file-upload/attachment-placeloader/attachment-placeloader.component';
export { AttachmentPreviewDialogComponent } from './lib/forms/file-upload/attachment-preview-dialog/attachment-preview-dialog.component';
export { FileUploadComponent } from './lib/forms/file-upload/file-upload/file-upload.component';
export { FormControlTouchStatusPatchDirective } from './lib/forms/form-control-touch-status-patch/form-control-touch-status-patch.directive';
export { FormErrorDirective } from './lib/forms/form-error/form-error.directive';
export { FormFieldComponent } from './lib/forms/form-field/form-field.component';
export { NumericInputComponent } from './lib/forms/numeric-input/numeric-input.component';

export { InputComponent } from './lib/forms/input/input.component';
export { MaskedInputComponent } from './lib/forms/masked-input/masked-input.component';
export { ProtectedControlDirective } from './lib/forms/protected-controls/protected-control.directive';
export {
  directiveContextFactory,
  ProtectedControlsContextDirective,
} from './lib/forms/protected-controls/protected-controls-context.directive';
export {
  useProtectedControlsCallback,
  protectedControlsGuardFn,
  ProtectedControlsGuardService,
} from './lib/forms/protected-controls/protected-controls-guard.service';
export {
  PROTECTED_CONTROLS_CONTEXT,
  ProtectedControlsContext,
} from './lib/forms/protected-controls/protected-controls.context';
export {
  protectedControlsRootProviders,
  providersForControlsContext,
} from './lib/forms/protected-controls/protected-controls.providers';
export { ProtectedControlsService } from './lib/forms/protected-controls/protected-controls.service';
export {
  RADIO_GROUP_VALUE_ACCESSOR,
  RadioFormGroupComponent,
} from './lib/forms/radio-form-group/radio-form-group.component';
export { RadioFormGroupItemComponent } from './lib/forms/radio-form-group/radio-form-group-item/radio-form-group-item.component';
export { RadioComponent } from './lib/forms/radio/radio.component';
export { RangeSelectionInputComponent } from './lib/forms/range-selection-input/range-selection-input.component';
export { SelectDropdownComponent } from './lib/forms/select/select-dropdown/select-dropdown.component';
export { SelectComponent } from './lib/forms/select/select.component';
export { TaggerComponent } from './lib/forms/tagger/tagger.component';
export { TextareaAutosizeDirective } from './lib/forms/textarea/textarea-autosize.directive';
export { TextareaComponent } from './lib/forms/textarea/textarea.component';
export { TimePickerDropdownComponent } from './lib/forms/time-picker/time-picker-dropdown/time-picker-dropdown.component';
export { TimePickerBridge } from './lib/forms/time-picker/time-picker-moment-bridge/time-picker-moment-bridge';
export { TimePickerComponent } from './lib/forms/time-picker/time-picker.component';
export { TimeZonePickerDropdownComponent } from './lib/forms/time-zone-picker/time-zone-picker-dropdown/time-zone-picker-dropdown.component';
export { TimeZonePickerComponent } from './lib/forms/time-zone-picker/time-zone-picker.component';
export { TypeaheadInlineComponent } from './lib/forms/typeahead/typeahead-inline.component';
export { TypeaheadInputDirective } from './lib/forms/typeahead/typeahead-input.directive';
export { TypeaheadSuggestionsComponent } from './lib/forms/typeahead/typeahead-suggestions.component';
export { TypeaheadComponent } from './lib/forms/typeahead/typeahead.component';
export { IconsContainerComponent } from './lib/icons-container/icons-container.component';
export { keyIconMap } from './lib/icons-container/icons-container.utils';
export { InputWithSelectDropdownComponent } from './lib/input-with-select/input-with-select-dropdown/input-with-select-dropdown.component';
export { InputWithSelectComponent } from './lib/input-with-select/input-with-select.component';
export {
  defaultIntersectionObserverAreaConfig,
  IntersectionObserverArea,
  IntersectionObserverAreaConfigToken,
  provideIntersectionObserverArea,
  provideIntersectionObserverAreaForDialog,
} from './lib/intersection-observer/intersection-observer-area';
export { IntersectionObserverEntryComponent } from './lib/intersection-observer/intersection-observer-entry.component';
export { ListSortableFormComponent } from './lib/lists/list-sortable-form/list-sortable-form.component';
export { ListSortableItemComponent } from './lib/lists/list-sortable-item/list-sortable-item.component';
export {
  ListSortableComponent,
  ListSortableComponentAction,
} from './lib/lists/list-sortable/list-sortable.component';

export { NewItemButtonComponent } from './lib/new-item-button/new-item-button.component';
export { NotificationBodyBase } from './lib/notifications/notification-body-base';
export {
  NotificationConfig,
  NotificationPosition,
  NotificationStyle,
} from './lib/notifications/notification-config';
export { NotificationData } from './lib/notifications/notification-data';
export { NotificationHostBase } from './lib/notifications/notification-host-base';
export { NotificationHostComponent } from './lib/notifications/notification-host/notification-host.component';
export { NotificationRef } from './lib/notifications/notification-ref';
export { NotificationsContainerComponent } from './lib/notifications/notifications-container/notifications-container.component';
export {
  FIXED_OVERLAY_LEVEL,
  NotificationsController,
} from './lib/notifications/notifications.controller';
export { TextSwapComponent } from './lib/notifications/text-swap.component';
export { RtUIOptions } from './lib/options';
export { PdfViewerComponent } from './lib/pdf-viewer/pdf-viewer.component';
export { ResizeObserverEntryDirective } from './lib/resize-observer/resize-observer-entry.directive';
export { SidebarFilterComponent } from './lib/sidebar/sidebar-filter/sidebar-filter.component';
export { SidebarGroupComponent } from './lib/sidebar/sidebar-group/sidebar-group.component';
export { SidebarItemComponent } from './lib/sidebar/sidebar-item/sidebar-item.component';
export { SidebarLabelComponent } from './lib/sidebar/sidebar-label/sidebar-label.component';
export { SidebarHeaderComponent } from './lib/sidebar/sidebar-header/sidebar-header.component';
export { SidebarService } from './lib/sidebar/sidebar.service';
export { SidebarComponent } from './lib/sidebar/sidebar/sidebar.component';
export { provideSocialMediaIconResolver } from './lib/social-media/social-media.resolver';
export { SocialMediaPipe, IconProvider } from './lib/social-media/social-media.pipe';
export { PlatformThemeService } from './lib/theme/platform-theme.service';
export { ThreadExpanderComponent } from './lib/thread-expander/thread-expander.component';
export { TourHighlightComponent } from './lib/tour-highlight/tour-highlight.component';
export { TourHighlightDirective } from './lib/tour-highlight/tour-highlight.directive';
export { TourHighlightService } from './lib/tour-highlight/tour-highlight.service';

export { chartColorsSet, getChartColorsSet } from './lib/utils/colors-sets';
export { RtInput, RtTextInput } from './lib/utils/rt-input';
export { deepFreeze } from './lib/utils/deep-freeze';
export { RtStatefulComponent } from './lib/utils/rt-stateful-component';
export * from './lib/utils/directives/file-handler/file-handler.directive';
export * from './lib/utils/directives/file-handler/file-handler-default-validator.directive';
export * from './lib/utils/directives/file-handler/file-handler.component';
export type { DialogConfirmOptions } from './lib/dialogs/dialogs.service';
export { ConfirmDialogVariant } from './lib/dialogs/dialogs.types';
export type { DropdownItem } from './lib/dropdown-scrollable/dropdown-scrollable.component';
export type { DatePickerDirection } from './lib/forms/date-picker/date-picker.component';
export type { AttachmentItemTranslations } from './lib/forms/file-upload/attachment-item/attachment-item.component';
export type { AttachmentPlaceloader } from './lib/forms/file-upload/attachment-placeloader/attachment-placeloader.types';
export type { RadioGroupItem } from './lib/forms/radio-form-group/radio-form-group.component';
export type { SelectGroupOption, SelectOptionValue } from './lib/forms/select/select.component';
export type { SelectOptionContext } from './lib/forms/select/select.component';
export type { SelectGroupedOptions, SelectOption } from './lib/forms/select/select.component';
export type { TypeaheadSuggestionsContext } from './lib/forms/tagger/tagger.component';
export type { TaggerTag } from './lib/forms/tagger/tagger.component';
export type { TimeData } from './lib/forms/time-picker/time-picker.component';
export type { SuggestionsTemplateContext } from './lib/forms/typeahead/typeahead-inline.component';
export type { SuggestionItemContext } from './lib/forms/typeahead/typeahead-suggestions.component';
export type { NestedIcon } from './lib/icons-container/icons-container.utils';
export type { IconName } from './lib/icons-container/icons.type';
export type { InputSelectDropdownOption } from './lib/input-with-select/input-with-select-dropdown/input-with-select-dropdown.component';
export type { IntersectionObserverTemplateContext } from './lib/intersection-observer/intersection-observer-entry.component';
export type { NotificationType } from './lib/notifications/notifications.controller';
export type { AnimState, MenuItem, SidebarItem } from './lib/sidebar/interfaces';
export { Colors } from './lib/variables/colors';
export { ZiggeoPlayerComponent } from './lib/ziggeo-player/ziggeo-player.component';
export { ZiggeoPlayerConfig } from './lib/ziggeo-player/ziggeo-player-config';
export { ziggeoPlayerRootProviders } from './lib/ziggeo-player/ziggeo-player-config';
export { UIRootProviders } from './lib/ui-providers';
export { PhoneInputComponent } from './lib/phone-input/phone-input.component';
export { PHONE_INPUT_DATA } from './lib/phone-input/phone-input.types';
export { ProviderItemComponent } from './lib/common/provider-item/provider-item.component';
export { PhoneNumberPipe } from './lib/phone-input/pipes/phone-number.pipe';
export * from './lib/utils/directives/accepted-file-types/accepted-file-types.directive';
export * from './lib/utils/directives/accepted-file-types/accepted-file-types.types';
export * from './lib/utils/directives/accepted-file-types/accepted-file-types.service';
export { HeaderDefaultComponent } from './lib/forms/select2/default-templates/header/header-default.component';
export { FooterDefaultComponent } from './lib/forms/select2/default-templates/footer/footer-default.component';
export { Select2FooterDirective } from './lib/forms/select2/default-templates/footer/footer.directive';
export { FooterResolverDirective } from './lib/forms/select2/default-templates/footer/footer-resolver.directive';
export { SelectController } from './lib/forms/select2/services/select-controller.service';
export { Select2ListItemDirective } from './lib/forms/select2/default-templates/list-item/list-item.directive';
export { Select2SelectedItemDirective } from './lib/forms/select2/default-templates/selected-item/selected-item.directive';
export { TriggerResolverDirective } from './lib/forms/select2/default-templates/trigger/trigger-resolver.directive';
export type { Select2GroupWithItems } from './lib/forms/select2/features/groups/groups-feature.directive';
export { GroupsFeatureDirective } from './lib/forms/select2/features/groups/groups-feature.directive';
export { MultiSelectTriggerComponent } from './lib/forms/select2/features/multiselect/trigger/trigger-default.component';
export { MultiselectFeatureDirective } from './lib/forms/select2/features/multiselect/multiselect-feature.directive';
export { Select2DefaultSearchComponent } from './lib/forms/select2/features/search/template/search-default.component';
export { HeaderResolverDirective } from './lib/forms/select2/default-templates/header/header-resolver.directive';
export { ListItemResolverDirective } from './lib/forms/select2/default-templates/list-item/list-item-resolver.directive';
export { SelectedItemResolverDirective } from './lib/forms/select2/default-templates/selected-item/selected-item-resolver.directive';

export { WithKeyNavDirective } from './lib/forms/select2/features/keyboard-feature.directive';

export { SelectedItemCounterResolverDirective } from './lib/forms/select2/features/multiselect/selected-item-counter/selected-item-counter-resolver.directive';
export { SearchResolverDirective } from './lib/forms/select2/features/search/template/search-resolver.directive';
export { Select2TriggerDirective } from './lib/forms/select2/default-templates/trigger/trigger.directive';

export { Select2TriggerComponent } from './lib/forms/select2/default-templates/trigger/trigger-default.component';
export { Select2Component } from './lib/forms/select2/select2.component';

export type { Select2Item } from './lib/forms/select2/types';
export { SelectedItemCounterDirective } from './lib/forms/select2/features/multiselect/selected-item-counter/selected-item-counter.directive';
export { Select2TriggerButtonComponent } from './lib/forms/select2/default-templates/trigger/trigger-button.component';
export { SearchFeatureDirective } from './lib/forms/select2/features/search/search-feature.directive';
export { Select2HeaderDirective } from './lib/forms/select2/default-templates/header/header.directive';
export { AlwaysOpenStrategyDirective } from './lib/forms/select2/strategies/open/always-open';
export { MultiSelectListItemComponent } from './lib/forms/select2/features/multiselect/list-item/list-item.component';
export { Select2HeaderTemplateDirective } from './lib/forms/select2/utils/header-template.directive';
export { positionPairs as OverlayPositionPairs } from './lib/core/overlay/overlay-directives';

export { FixedSelectOptionsHelper } from './lib/fixed-select-options/fixed-select-options.helper';
export { FixedSelectOptionsTranslations } from './lib/fixed-select-options/fixed-select-options.translations';

export { DrawerContainerComponent } from './lib/drawer/components/drawer-container/drawer-container.component';
export { DrawerTriggerDirective } from './lib/drawer/directives/drawer-trigger.directive';
export type { DrawerContainerWidthConfig } from './lib/drawer/types';
export { DrawerState } from './lib/drawer/types';
export { E2ESelectorDirective } from './lib/e2e-helpers/e2e-selector.directive';
export * from './lib/dialog/dialog-toolbar/toolbar-radius-toggle.directive';
export * from './lib/common/collapsible-card/collapsible-card.component';
export * from './lib/common/collapsible-card/collapsed-card-child.component';
export * from './lib/common/user-list-tooltip/user-list-tooltip.component';

export {
  injectPdfViewerErrorContexts,
  providePdfViewerErrorContexts,
} from './lib/pdf-viewer/pdf-viewer.di';

export type { PdfViewerErrorContexts } from './lib/pdf-viewer/pdf-viewer.types';
